var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"stational_monitor"}},[_c('Operations'),_vm._v(" "),_c('div',{staticClass:"ui divider"}),_vm._v(" "),_c('CoreWaybillsUnderOperations')],1)}
var staticRenderFns = []

export { render, staticRenderFns }